import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import { GetMyWalletDocument, GetWalletByEmployeeIdDocument } from './schema.graphql';
import { GetMyWalletQuery, GetMyWalletQueryVariables, GetWalletByEmployeeIdMutationVariable, GetWalletByEmployeeIdQuery } from 'src/app/model/wallet';


@Injectable({
  providedIn: 'root'
})
export class GetWalletByEmployeeIdGQL extends Apollo.Query<GetWalletByEmployeeIdQuery, GetWalletByEmployeeIdMutationVariable> {
  document = GetWalletByEmployeeIdDocument;
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

/** Saldo do proprio colaborador: a API resolve pelo token, sem depender de employeeId. */
@Injectable({
  providedIn: 'root'
})
export class GetMyWalletGQL extends Apollo.Query<GetMyWalletQuery, GetMyWalletQueryVariables> {
  document = GetMyWalletDocument;
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
